import type { TowerDesign } from "@/game/towerSpec";
/** EXACT: Sabre 280ft S3R Series SD self-supporting tower, TIA-222-H 107 mph Exp C. Three-legged. Face taper estimated base ~22ft/top ~4ft (Sabre S3R proportions). */
export const design: TowerDesign = {
  id: "selfsupport-sabre-s3r-280ft",
  name: "Self-Support (Sabre S3R 280 ft)",
  description: "Real 280 ft Sabre S3R Series SD self-support tower (TIA-222-H, 107 mph, Exp C).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "lattice",
    height: 85.34,
    stack: { faces: 3, panels: 22, baseRadius: 3.87, topRadius: 0.70,
      legSection: "legXXL", braceSection: "angleL5", legMaterial: "a572", braceMaterial: "a36", bracing: "X" },
    foundation: { soil: "dense-sand", base: { type: "pad", width: 2.5, diameter: 1, depth: 2.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 8, bolt: "b1_5", grade: "f1554_55", boltCircleDia: 0.7, embedment: 0.8, edgeDistance: 0.35, platePlanArea: 0.5, plateThickness: 0.045, plateGrade: "a36rod", fc: 30e6 } },
  },
};
